import { render } from "./DisclaimerView.vue?vue&type=template&id=07c802cc"
import script from "./DisclaimerView.vue?vue&type=script&lang=js"
export * from "./DisclaimerView.vue?vue&type=script&lang=js"

import "./DisclaimerView.vue?vue&type=style&index=0&id=07c802cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__